import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';

import { routes } from './app-routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { HttpRequestInterceptor } from '@security/http-request.interceptor';
import { ErrorInterceptor } from '@security/error.interceptor';
import { AuthService } from '@services/auth.service';
import { catchError, firstValueFrom, of } from 'rxjs';
import { ToastrInterceptor } from '@security/toastr.interceptor';
import { provideRouter } from '@angular/router';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';

export function appInitializer(authService: AuthService) {
  const platformId = inject(PLATFORM_ID);
  return () => {
    // if (!isPlatformBrowser(platformId)) {
    //   return Promise.resolve();
    // }
    // const url = new URL(window.location.href);
    // const token = url.searchParams.get('token');

    // authService.getLoggedUser(token).subscribe({}).add(resolve);

    return firstValueFrom(
      authService.getLoggedUser().pipe(
        tap( (r) => console.log('I am in tap: ', r)),
        catchError((e) => {
          // console.error('error here: ', e);
          return of({});
        })
      )
    );

  };
}

// const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => new TranslateHttpLoader(http);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    importProvidersFrom([BrowserModule, MatDialogModule]),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAppInitializer(() => {
      const initializerFn = (appInitializer)(inject(AuthService));
      return initializerFn();
    }),
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ToastrInterceptor, multi: true},
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({prefix: './assets/i18n/', suffix: '.json'}),
      // loader: {
      //   provide: TranslateLoader,
      //   useFactory: httpLoaderFactory,
      //   deps: [HttpClient],
      // },
    }), provideClientHydration(withEventReplay())
  ]
};
